import { NEXT_PUBLIC_POS_SERVICE_URL } from "@/modules/config";

let isRefreshing = false;
let refreshPromise: Promise<void> | null = null;

export async function refreshAccessToken(): Promise<void> {
  if (isRefreshing && refreshPromise) {
    return refreshPromise;
  }

  isRefreshing = true;
  refreshPromise = fetch(`${NEXT_PUBLIC_POS_SERVICE_URL}/api/auth/refresh`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Cookie-Path": "/",
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to refresh token: ${response.status}`);
      }
      return;
    })
    .catch((error) => {
      throw error;
    })
    .finally(() => {
      isRefreshing = false;
      refreshPromise = null;
    });

  return refreshPromise;
}
